

import React, { useState, useEffect } from "react";
import downloadImg from "../../../assets/download-img.svg";
import loader from "../../../assets/loader.svg";
import Meeting from "../../Model/MeetingModal";
import { useNavigate } from "react-router-dom";



const MonitoringReports = ({page}) => {
  const sampleReports = [
    {
      id: 1,
      title: "CUFS",
      link: "#",
      state: { category: { label: "CUFS", value: "cufs" , page } },
      not_for: [""],
    },
    {
      id: 2,
      title: "DBE Plan",
      link: "https://dev.contractorcn.com/resources_file/WAH_DBE_Plan.pdf",
      link: "#",
      state: { category: { label: "DBE plans", value: "dbe" , page } },
      not_for: [""],
    },
    {
      id: 3,
      title: "Economic Reports",
      link: "#",
      state: {
        category: { label: "Economic Reports", value: "economic_reports" , page},
      },
      not_for: ["MRB"],
    },
    {
      id: 4,
      title: "Meeting & Attendance Records",
      link: "#",
      not_for: ["MRB"],
    },
  ];

  const navigate = useNavigate(); // Define navigate

  const [reportList, setReportList] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => setModalOpen(false);
  useEffect(() => {
    setShowLoader(true);
    setTimeout(() => {
      setReportList(sampleReports);
      setShowLoader(false);
    }, 1000); // Simulate loading
  }, []);

  return (
    <div className="card w-100 h-100 bg-white rounded-3 shadow-sm mb-4 border-0">
      <div className="card-header g-0 m-0 p-0 overflow-hidden border-bottom border-light border-2">
        <div className="row g-0">
          <div className="col g-0">
            <div className="float-end text-secondary point-16 mb-2 fw-boldest pt-4 me-4">
              {/* + Add&nbsp;
              <span className="text-danger">contacts</span> */}
            </div>
            <h3 className="p-3 mb-0 pb-0 point-22 text-uppercase text-primary fw-bold">
              Monitoring Reports
            </h3>
          </div>
          <div className="col-auto bg-secondary">
            <div className="rounded-pill bg-secondary w-100">
              <div className="d-flex flex-column justify-content-center">
                <img src={downloadImg} className="header-icon m-2" alt="logo" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-body p-3">
        {!showLoader ? (
          reportList.length > 0 ? (
            <ul className="list-group py-3 pe-3 mh-20">
              {reportList
                .filter((report) => !report.not_for?.includes(page)) // exclude if 'not_for' includes 'mrb'
                .map((report) => {
                  const hasLink =
                    report.link &&
                    report.link.trim() !== "" &&
                    report.link.trim() !== "#";

                  return (
                    <li
                      key={report.id}
                      className="list-group-item py-3 mb-3 d-flex align-items-center bg-light border border-1 rounded-0"
                    >
                      <div className="w-100 d-flex justify-content-between align-items-center flex-nowrap">
                        <div
                          className="text-primary fw-bold point-18 me-2 text-truncate"
                          style={{
                            maxWidth: "65%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={report.title}
                        >
                          {report.title}
                        </div>

                        {report.id === 4 ? (
                          <button
                            className="btn btn-primary rounded-pill point-18"
                            onClick={handleModalOpen}
                          >
                            View
                          </button>
                        ) : (
                          <a
                           // href={hasLink || true ? report.link : undefined}
                            className={`text-decoration-none btn-with-svg point-18 btn rounded-pill ${
                              hasLink || true ? "btn-primary" : "btn-secondary disabled"
                            }`}
                            // target={hasLink || true ? "_blank" : undefined}
                            rel={hasLink || true ? "noopener noreferrer" : undefined}
                            onClick={(e) => {
                              navigate("/Reports", { state: report.state });
                            }}
                          >
                            View
                          </a>
                        )}
                      </div>
                    </li>
                  );
                })}
            </ul>
          ) : (
            <div className="d-flex justify-content-center py-3">
              <p className="text-muted">No Reports Found.</p>
            </div>
          )
        ) : (
          <div className="d-flex justify-content-center py-3">
            <img src={loader} alt="Loading..." className="loader" />
          </div>
        )}
      </div>

      {modalOpen && <Meeting open={modalOpen} handleClose={handleModalClose} page={page}/>}
    </div>
  );
};

export default MonitoringReports;

